import { render, staticRenderFns } from "./Correspondent.vue?vue&type=template&id=10b60c05"
import script from "./Correspondent.vue?vue&type=script&lang=js"
export * from "./Correspondent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports